export default __webpack_public_path__ + "static/media/lost-baggage.32a4cf50.png";